module.exports = __webpack_public_path__ + "static/media/golden-demand.ce6409c6.png";